export const UserAccountIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 6.74988H13.5"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M10.5 9.37488H12.75"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M12.75 2.24988H5.25C3.17893 2.24988 1.5 3.92881 1.5 5.99988V11.9999C1.5 14.0709 3.17893 15.7499 5.25 15.7499H12.75C14.8211 15.7499 16.5 14.0709 16.5 11.9999V5.99988C16.5 3.92881 14.8211 2.24988 12.75 2.24988Z"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 11.9999C4.65623 10.0641 8.03415 9.93671 9 11.9999"
        stroke="#31394A"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.875 6.74988C7.875 7.57827 7.20343 8.24989 6.375 8.24989C5.54657 8.24989 4.875 7.57827 4.875 6.74988C4.875 5.92145 5.54657 5.24988 6.375 5.24988C7.20343 5.24988 7.875 5.92145 7.875 6.74988Z"
        stroke="#31394A"
        strokeWidth="1.25"
      />
    </svg>
  );
};
